import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component4cards from '../components/component4cards'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './service.css'

const Service = (props) => {
  return (
    <div className="service-container">
      <Helmet>
        <title>Сервис и обслуживание промышленных роботов | Arcobo</title>
        <meta
          name="description"
          content="Сервис промышленных роботов Kawasaki, KUKA, FANUC и Yaskawa. Диагностика, ремонт, модернизация и техническая поддержка предприятий Казахстана и Узбекистана."
        />
        <meta
          property="og:title"
          content="Сервис и обслуживание промышленных роботов | Arcobo"
        />
        <meta
          property="og:description"
          content="Сервис промышленных роботов Kawasaki, KUKA, FANUC и Yaskawa. Диагностика, ремонт, модернизация и техническая поддержка предприятий Казахстана и Узбекистана."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Сервис и обслуживание промышленных роботов | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Сервис промышленных роботов Kawasaki, KUKA, FANUC и Yaskawa. Диагностика, ремонт, модернизация и техническая поддержка предприятий Казахстана и Узбекистана."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/service"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/service"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Service","item":"https://arcobo.tech/service"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name30"></HeaderMain>
      <Componenttextimage
        image1Src="/4_Company Arcobo/4_5_Service/service%20main-1500w.webp"
        image1Alt="Сервис и обслуживание промышленных роботов"
        rootClassName="componenttextimageroot-class-name17"
        textComponent={
          <Fragment>
            <span className="service-text10">
              <span>
                Arcobo выполняет сервисное обслуживание, диагностику, ремонт и
                модернизацию промышленных роботов на предприятиях Казахстана,
                Узбекистана и Центральной Азии. Мы работаем как с отдельными
                промышленными роботами, так и с полностью автоматизированными
                производственными линиями.
              </span>
              <br></br>
              <br></br>
              <span>
                Наши инженеры имеют опыт работы с роботами Kawasaki Robotics,
                KUKA, FANUC и Yaskawa, выполняя механический ремонт,
                восстановление работоспособности, программирование, настройку
                сварочных процессов и модернизацию существующих роботизированных
                комплексов.
              </span>
            </span>
          </Fragment>
        }
        componentTitle="Сервис и обслуживание промышленных роботов"
      ></Componenttextimage>
      <Component4cards
        title1="Диагностика неисправностей "
        title2="Настройка и оптимизация программ"
        title3="Плановое техническое обслуживание"
        title4="Ремонт промышленных роботов"
        heading1="Сервис и техническое сопровождение"
        imageSrc="/icons/diagnostics-200w.webp"
        imageAlt="Диагностика неисправностей"
        imageSrc1="/icons/tuning-200w.webp"
        imageAlt1="Настройка и оптимизация программ"
        imageSrc2="/icons/maintenance-200w.webp"
        imageAlt2="Плановое техническое обслуживание"
        imageSrc3="/icons/repair-200w.webp"
        imageAlt3="Ремонт промышленных роботов"
        description1="Поиск механических, электрических и программных неисправностей с рекомендациями по их устранению"
        description2="Корректировка программ робота, сокращение времени цикла и повышение стабильности работы"
        description3="Регламентное обслуживание, проверка узлов, замена смазки и профилактика отказов оборудования"
        description4="Восстановление работоспособности после аварий, износа или выхода из строя компонентов"
        rootClassName="component4cardsroot-class-name3"
      ></Component4cards>
      <Component4cards
        title1="Обучение операторов"
        title2="Оффлайн-программирование"
        title3="Разработка технологий"
        title4="Подготовка сервисных инженеров"
        heading1="Обучение и развитие компетенций"
        imageSrc="/icons/education-200w.webp"
        imageAlt="Обучение операторов"
        imageSrc1="/icons/programming-200w.webp"
        imageAlt1="Оффлайн-программирование"
        imageSrc2="/icons/gear-200w.webp"
        imageAlt2="Разработка технологий"
        imageSrc3="/icons/engineer-200w.webp"
        imageAlt3="Подготовка сервисных инженеров"
        description1="Практическая подготовка операторов по безопасной эксплуатации и ежедневной работе с роботами"
        description2="Создание и отработка программ в виртуальной среде без остановки производства"
        description3="Подбор режимов сварки, траекторий движения и иных технологических процессов под конкретную задачу"
        description4="Обучение диагностике, техническому обслуживанию и ремонту промышленных роботов на автомбильных предприятиях"
        rootClassName="component4cardsroot-class-name4"
      ></Component4cards>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="service-text15">
              Мы выполняем сервисное обслуживание промышленных роботов Kawasaki
              Robotics, KUKA, FANUC и Yaskawa. Также можем проводить диагностику
              и модернизацию роботизированных комплексов других производителей
              после предварительного технического аудита.
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="service-text16">
              Плановое техническое обслуживание включает замену смазки, проверку
              состояния редукторов, тормозов, кабельных пакетов и балансиров,
              контроль давления газа в пневматических балансирах (при наличии),
              тестирование повторяемости, резервное копирование программ и
              проверку работы систем безопасности
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="service-text17">
              Да. Мы обслуживаем не только собственные проекты Arcobo. Если
              оборудование технически доступно для диагностики и ремонта, наши
              инженеры могут взять его на сервисное сопровождение независимо от
              того, кто выполнял первоначальную интеграцию.
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="service-text18">
              Да. Мы разрабатываем новые программы, корректируем существующие,
              оптимизируем траектории движения, сокращаем время цикла,
              настраиваем сварочные режимы и интегрируем дополнительное
              оборудование в роботизированные комплексы.
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="service-text19">
              Основные работы выполняются в Казахстане, однако Arcobo также
              оказывает сервисную поддержку предприятий Узбекистана и других
              стран Центральной Азии.
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="service-text20">
              Да. Для предприятий с роботизированным производством мы предлагаем
              долгосрочное сервисное сопровождение с плановыми выездами
              инженеров, профилактическим обслуживанием, удаленной технической
              поддержкой и оперативным реагированием при возникновении
              неисправностей.
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="service-text21">
              Да. Мы проводим обучение операторов, программистов и сервисных
              инженеров промышленных роботов и роботизированных комплексов.
            </span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="service-text22">answer</span>
          </Fragment>
        }
        showDiv={false}
        showDiv1={false}
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        showDiv6={false}
        showDiv7
        question1="Какие марки промышленных роботов обслуживает Arcobo?"
        question2="Что входит в техническое обслуживание промышленного робота?"
        question3="Можно ли обслуживать робот другого интегратора?"
        question4="Выполняете ли вы программирование промышленных роботов?"
        question5="Работаете ли вы только в Казахстане?"
        question6="Можно ли заключить договор на регулярное сервисное обслуживание?"
        question7="Можно ли пройти обучение у Arcobo?"
        rootClassName="componentfaqroot-class-name15"
      ></Componentfaq>
      <FooterMain></FooterMain>
    </div>
  )
}

export default Service
